import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { RouteComponentProps } from 'react-router';
import { VoucherPage } from './VoucherPage';
import { VoucherEditPage } from './VoucherEditPage';

export interface VoucherPageRoutingProps extends RouteComponentProps { }

export const VoucherPageRouting = (props: VoucherPageRoutingProps) => {
  return (
    <Switch>
      <Route
        path={`${props.match.path}/:voucherUuid/edit`}
        component={VoucherEditPage}
        exact
      />
      <Route
        path={`${props.match.path}/:voucherUuid`}
        component={VoucherPage}
        exact
      />
    </Switch>
  );
};